import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { QrCode, Copy, Check, Share2, ArrowLeft } from 'lucide-react';
import { toast } from 'sonner';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { QRCodeSVG } from 'qrcode.react';
import Navigation from '../components/Navigation';
import { LOGO_RAIZES_WHITE } from '../lib/branding';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const QRCodeVoluntarios = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);

  const shareLink = `https://raizesif.kingdomcloud.com.br/cadastro-voluntario-publico`;

  const copyLink = () => {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = shareLink;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      setCopied(true);
      toast.success('Link copiado!');
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Nao foi possivel copiar.');
    }
  };

  const shareWhatsApp = () => {
    const text = encodeURIComponent(`Faca seu cadastro como voluntario no Ministerio Raizes!\n\n${shareLink}`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] pb-24">
      <div className="bg-[#1A4D2E] text-white px-6 py-8">
        <div className="max-w-lg mx-auto">
          <button onClick={() => navigate(-1)} className="hover:bg-white/10 rounded-full p-2 transition-all mb-2" data-testid="back-btn">
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <QrCode className="w-7 h-7" />
              <h1 className="font-nunito font-bold text-2xl">QR Code Voluntários</h1>
            </div>
            <img src={LOGO_RAIZES_WHITE} alt="Ministério Raízes" className="h-10" />
          </div>
          <p className="font-inter text-white/70 text-sm mt-1">Compartilhe para novos voluntarios se cadastrarem</p>
        </div>
      </div>

      <div className="max-w-lg mx-auto px-4 py-6 space-y-6">
        <Card className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 text-center" data-testid="qr-card">
          <div className="inline-block p-4 bg-white rounded-2xl shadow-lg border border-gray-100 mb-4">
            <QRCodeSVG
              value={shareLink}
              size={200}
              bgColor="#ffffff"
              fgColor="#1A4D2E"
              level="H"
              data-testid="qr-code"
            />
          </div>
          <p className="font-nunito font-bold text-lg text-[#1A4D2E] mb-1">Cadastro de Voluntários</p>
          <p className="font-inter text-sm text-gray-500 mb-4">Escaneie o QR Code ou compartilhe o link</p>

          <div className="bg-gray-50 rounded-xl p-3 flex items-center gap-2 mb-4">
            <p className="flex-1 text-xs text-gray-600 truncate font-mono" data-testid="share-link">{shareLink}</p>
            <Button
              size="sm"
              variant={copied ? "default" : "outline"}
              onClick={copyLink}
              data-testid="copy-btn"
              className="shrink-0"
            >
              {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            </Button>
          </div>

          <Button
            onClick={shareWhatsApp}
            data-testid="whatsapp-btn"
            className="w-full bg-green-600 hover:bg-green-700 text-white gap-2"
          >
            <Share2 className="w-4 h-4" /> Compartilhar via WhatsApp
          </Button>
        </Card>
      </div>
      <Navigation active="inicio" />
    </div>
  );
};

export default QRCodeVoluntarios;
